<!-- 组件说明 -->
<template>
  <div class="con detailImgContainer">
    <div class="meal-box" v-if="goodsType == 2">
      <div class="t">
        <div class="title"><i></i><span>套餐商品</span></div>
        <div class="item-box">
          <div
            class="meal-item"
            v-for="(item, index) in gooodsDetail.goodsCombinationItemResults"
            :key="index"
          >
            <div class="item-img">
              <img v-lazy="item.image ? item.image : $defaultImg" alt="" />
            </div>
            <div class="item-con">
              <p>{{ item.name }}</p>
              <span class="span1">×{{ item.quantity }}</span>
              <span class="span2">{{ item.manufacturer }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="b-meal">
        <div class="title"><i></i><span>套餐详情</span></div>
        <div class="bigimgbox" ref="bigimgbox"></div>
        <!-- v-html="gooodsDetail.content" -->
      </div>
    </div>
    <div class="common-box" v-if="goodsType == 1">
      <div class="title"><i></i><span>商品详情</span></div>
      <div class="bigimgbox" ref="bigimgbox"></div>
      <!-- v-html="gooodsDetail.content" -->

      <!-- <div class="bigimgbox" v-for="(item,index) in gooodsDetail.images" :key="index">
         <img v-lazy="item.large" alt="">
        
      </div> -->
    </div>
  </div>
</template>

<script>
//import x from ''
let container = null;
let observer = null;
export default {
  components: {},
  props: ["gooodsDetail", "goodsType"],
  data() {
    return {
      type: 2
    };
  },
  watch: {
    gooodsDetail(val) {
      this.$nextTick(() => {
        this.text2Html();
      });
    }
  },
  computed: {},
  methods: {
    todetail(id) {
      this.$router.push({ name: "detail", query: { goodsId: id, type: 1 } });
    },
    // 将字符串转换为元素 并监听元素与视窗的相交
    text2Html() {
      if (!observer) {
        observer = new IntersectionObserver(
          els => {
            els.forEach(el => {
              if (el.isIntersecting) {
                el.target.src = el.target.dataset.src;
                observer.unobserve(el.target);
              }
            });
          },
          {
            rootMargin: "0px",
            threshold: [0.7]
          }
        );
      }
      // const reg = /(?<=src=')([\s\S]*?)(?=')/g;
      const imgTagReg = /<img[\s\S]*?src=['"]([\s\S]*?)["'][\s\S]*?\/>/g;
      const Html = this.gooodsDetail.content.replace(
        imgTagReg,
        `<img data-src="$1" class="img" />`
      );
      container = document.createElement("div");
      container.innerHTML = Html;
      const imgs = [...container.children].filter(el => el.tagName === "IMG");
      imgs.forEach(el => {
        el.style.cssText = "min-height:400px;min-width:100%";
        observer.observe(el);
      });
      const bigimgbox = this.$refs.bigimgbox;
      bigimgbox.innerHTML = "";
      bigimgbox.append(...container.childNodes);
    }
  },
  mounted() {
    this.text2Html();
  },
  beforeDestroy() {
    observer.disconnect();
    // 清除引用
    observer = null;
    container = null;
  } //生命周期 - 销毁之前
};
</script>

<style lang="scss" scoped>
.detailImgContainer {
  border-top: 1px solid #f7f7f7;
  margin-top: 24px;
  padding-top: 24px;
}
.t,
.common-box,
.b-meal {
  .title {
    margin-bottom: 24px;
    i {
      display: inline-block;
      height: 18px;
      width: 4px;
      background-color: #fa4b4b;
      margin-right: 6px;
    }
    span {
      font-size: 18px;
      color: #333333;
    }
  }
}
.t {
  margin: 24px 0 38px 0;
}
.item-box {
  display: flex;
  flex-wrap: wrap;
}
.meal-item {
  display: flex;
  width: 250px;
  margin-right: 26px;
  flex-shrink: 0;
  margin-bottom: 15px;
  .item-img {
    width: 80px;
    height: 80px;
    flex-shrink: 0;
    img {
      @include size(100%, 100%);
    }
  }
  .item-con {
    @include flex-d-c;
    justify-content: space-around;
    padding: 0 10px;
    width: 190px;
    p {
      font-size: 14px;
      color: #505050;
      @include textLineClamp(2);
    }
    .span1 {
      font-size: 14px;
      color: #fa4b4b;
    }
    .span2 {
      font-size: 12px;
      color: #999999;
      @include textLineClamp(1);
    }
  }
}
.b-meal,
.common-box {
  .bigimgbox {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/detail/components/goods-detail-img.vue